import * as Actions from '../actions';
import moment from 'moment';

const initialState = {
    rebuildGradebook: {
        completed: false
    }
}

const utilReducer = function (state = initialState, action) {
    switch (action.type) {
        case(Actions.REBUILD_GRADEBOOK):
            {
                return {
                    ...state,
                    rebuildGradebook: {
                        completed: true
                    }
                }
            }
        default:
            {
                return state;
            }

    }
}

export default utilReducer;


// WEBPACK FOOTER //
// src/main/content/utils/store/reducers/utils.reducer.js